import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    setFiltroPublicacion
} from '../../../actions/publicacionesActions';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { customStyle } from '../../../template/CustomStyle'
import { DropDownArrow } from "../../../template/CustomStyle";
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
const fechaFiltro = filtroMedioMes();


class PublicacionesFilter extends React.Component {
    constructor(props) {
        super(props);
        let estado = "";
        if (this.props.filtro != "") { estado = this.switchEstado(this.props.filtro.estado) }
        this.state = {
            skuSeller: this.props.filtro != "" ? this.props.filtro.skuSeller : "",
            marca: {
                label: this.props.filtro != "" ? this.props.filtro.marcaLabel : "",
                value: this.props.filtro != "" ? this.props.filtro.value : ""
            },
            categoria: {
                label: this.props.filtro != "" ? this.props.filtro.categoriaLabel : "",
                value: this.props.filtro != "" ? this.props.filtro.categoria : ""
            },
            seller: {
                label: this.props.filtro != "" ? this.props.filtro.idSellerLabel : "",
                value: this.props.filtro != "" ? this.props.filtro.idSeller : ""
            },
            estado: {
                label: estado,
                value: this.props.filtro != "" ? this.props.filtro.estado : ""
            },
            idTipoPublicacion: {
                label: this.props.filtro != "" ? this.props.filtro.idTipoPublicacionLabel : "",
                value: this.props.filtro != "" ? this.props.filtro.idTipoPublicacion : ""
            },
            sinStock: {
                label: this.props.filtro != "" ? this.props.filtro.sinStockLabel : "",
                value: this.props.filtro != "" ? this.props.filtro.sinStock : ""
            },
            fechaPubDesde: this.props.filtro != "" ? this.props.filtro.fechaPubDesde : fechaFiltro.desde,
            fechaPubHasta: this.props.filtro != "" ? this.props.filtro.fechaPublicacionHasta : fechaFiltro.hasta,
            skuMarket: this.props.filtro != "" ? this.props.filtro.skuMarket : "",
            variaciones: [],
            tipoPublicacion: [],
        }
    }

    onSelectSearchInputCategorias = (descripcion) => {
        this.props.fetchCategorias(descripcion);
    }

    onSelectSearchInputMarcas = (descripcion) => {
        this.props.fetchMarcas(descripcion);
    }

    onSelectSearchInputSellers = (descripcion) => {
        this.props.fetchSellersFilter({ descripcion });
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    }

    onFilter = (event) => {
        event.preventDefault();

        this.props.setInitialPage();

        let params = {
            estado: this.state.estado.value,
            estadoLabel: this.state.estado.label,
            marca: this.state.marca.value,
            marcaLabel: this.state.marca.label,
            categoria: this.state.categoria.value,
            categoriaLabel: this.state.categoria.label,
            idSeller: this.state.seller.value,
            idSellerLabel: this.state.seller.label,
            idTipoPublicacion: this.state.idTipoPublicacion.value,
            idTipoPublicacionLabel: this.state.idTipoPublicacion.label,
            skuSeller: this.state.skuSeller,
            skuMarket: this.state.skuMarket,
            fechaPubDesde: this.state.fechaPubDesde,
            fechaPubHasta: this.state.fechaPublicacionHasta,
            sinStock: this.state.sinStock.value,
            sinStockLabel: this.state.sinStock.label
        }

        if (this.state.skuMarket != "") {
            params = this.buscarPorSKUMarketSOLO(params);
        }

        if (!this.props.allowSearchBySeller) {
            params.idSeller = this.props.idSeller;
        }

        this.props.setFiltroPublicacion(params);
        this.props.fetchPublicaciones(params);
    }

    buscarPorSKUMarketSOLO = (params) => {
        if (params.skuMarket != null) {
            params = {
                estado: this.state.estado.value,
                estadoLabel: this.state.estado.label,
                marca: this.state.marca.value,
                marcaLabel: this.state.marca.label,
                categoria: this.state.categoria.value,
                categoriaLabel: this.state.categoria.label,
                idSeller: this.state.seller.value,
                sellerLabel: this.state.seller.label,
                skuSeller: this.state.skuSeller,
                skuMarket: this.state.skuMarket,
                idTipoPublicacion: this.state.idTipoPublicacion.value,
                idTipoPublicacionLabel: this.state.idTipoPublicacion.label,
                fechaPubDesde: null,
                fechaPubHasta: null,
                sinStock: this.state.sinStock.value,
                sinStockLabel: this.state.sinStock.label
            }
        }
        return params;
    }

    onClearFilter = (event) => {
        event.preventDefault();
        this.props.setInitialPage();

        let params = {
            idSeller: this.props.allowSearchBySeller ? null : this.props.idSeller,
            fechaPubHasta: fechaFiltro.hasta,
            fechaPubDesde: fechaFiltro.desde
        }

        this.props.fetchPublicaciones(params);
        this.props.setFiltroPublicacion(params);
        localStorage.removeItem("pagina");
    
        this.setState({
            marca: { label: "", value: "" },
            categoria: { label: "", value: "" },
            estado: { label: "", value: "" },
            seller: { label: "", value: "" },
            skuSeller: "",
            skuMarket: "",
            fechaPubDesde: fechaFiltro.desde,
            fechaPubHasta: fechaFiltro.hasta,
            idTipoPublicacion: { label: "", value: "" },
            sinStock: { label: "", value: "" }
        })
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name == "fechaPubDesde") {
            this.setState({ fechaPubDesde: event.target.value })
        }
        if (event.target.name == "fechaPublicacionHasta") {
            this.setState({ fechaPubHasta: event.target.value })
        }
    }

    mapVariaciones = () => {
        let variaciones = [];
        if (this.props.variaciones) {
            this.props.variaciones.map(variacion =>
                variaciones.unshift({
                    label: this.switchEstado(variacion.descripcion),
                    value: variacion.descripcion
                })
            );
        }
        this.setState({ variaciones: variaciones });
    }

    mapTipoPublicacion = () => {
        let tipoPublicacion = [];

        if (this.props.tipoPublicacion) {
            this.props.tipoPublicacion.map(item =>
                tipoPublicacion.unshift({
                    label: item.descripcion,
                    value: item.codigo
                })
            );
        }
        this.setState({ tipoPublicacion: tipoPublicacion })
    }

    switchEstado = (estado) => {
        switch (estado) {
            case "activo":
                return "ACTIVO"
            case "pendiente_activacion":
                return "PENDIENTE"
            case "pausado":
                return "PAUSADO"
            case "en_revision":
                return "EN REVISIÓN"
            default:
                return estado
        }
    }

    mapSellers = () => {
        let opcionTodos = { value: "", label: "Todos" };
        this.props.sellers.unshift(opcionTodos);
    }


    render() {
        const { loadingPublicaciones, allowSearchBySeller } = this.props;

        let listaSeller = [];
        if (this.props.sellers != undefined) {
            this.props.sellers.map((item) => {
                listaSeller.push({ label: item.label, value: item.value.toString() })
            });
        }

        let listaCategoria = [];
        if (this.props.categorias != undefined) {
            this.props.categorias.map((item) => {
                listaCategoria.push({ label: item.label, value: item.value.toString() })
            });
        }

        let listaMarca = [];
        if (this.props.marcas != undefined) {
            this.props.marcas.map((item) => {
                listaMarca.push({ label: item.label, value: item.value.toString() })
            });
        }

        const stockOpciones = [
            { value: undefined, label: "Todos" },
            { value: true, label: "Sin Stock" },
            { value: false, label: "Con Stock" }
        ];

        let classIsModerador = allowSearchBySeller ? "col-lg-2" : "col-lg-3";

        return (
            <div className="card card-body filter-card">
                <form 
                    className="row form-material"
                    onSubmit={this.onFilter}
                    onReset={this.onClearFilter}    
                >

                    {allowSearchBySeller &&
                        <div className={classIsModerador}>
                            <label className="label-oscura">Seller</label>
                            <Select
                                name="seller"
                                value={this.state.seller}
                                options={listaSeller}
                                onChange={this.selectSearchHandler}
                                onMenuOpen={this.mapSellers}
                                onInputChange={this.onSelectSearchInputSellers}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                            />
                        </div>
                    }

                    <div className={classIsModerador}>
                        <label className="label-oscura">Sku Seller</label>
                        <input
                            type="text"
                            name="skuSeller"
                            onChange={this.handleChange}
                            value={this.state.skuSeller}
                            className="form-control"
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label className="label-oscura">Sku Market</label>
                        <input
                            type="text"
                            name="skuMarket"
                            onChange={this.handleChange}
                            value={this.state.skuMarket}
                            className="form-control"
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label className="label-oscura">Marca</label>
                        <Select
                            name="marca"
                            value={this.state.marca}
                            options={listaMarca}
                            onInputChange={this.onSelectSearchInputMarcas}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                        />
                    </div>
                    <div className={classIsModerador}>
                        <label className="label-oscura">Categoria</label>
                        <Select
                            name="categoria"
                            value={this.state.categoria}
                            options={listaCategoria}
                            onInputChange={this.onSelectSearchInputCategorias}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                        />
                    </div>
                    <div className={classIsModerador}>
                        <label className="label-oscura">Estado</label>
                        <Select
                            name="estado"
                            options={this.state.variaciones}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            onMenuOpen={this.mapVariaciones}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                        />
                    </div>

                    <div
                        name="fechaPubDesde"
                        className={classIsModerador}
                        onMouseEnter={this.handleChange}
                    >
                        <label className="label-oscura">Fecha desde</label>
                        <input
                            type="date"
                            name="fechaPubDesde"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.fechaPubDesde}
                        />
                    </div>

                    <div
                        className={classIsModerador}
                        name="fechaPublicacionHasta"
                        onMouseEnter={this.handleChange}
                    >
                        <label className="label-oscura">Fecha hasta</label>
                        <input
                            type="date"
                            name="fechaPublicacionHasta"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.fechaPubHasta}
                        />
                    </div>

                    {allowSearchBySeller &&
                        <div className="col-lg-2">
                            <label className="label-oscura">Tipo publicación</label>
                            <Select
                                name="idTipoPublicacion"
                                options={this.state.tipoPublicacion}
                                onChange={this.selectSearchHandler}
                                value={this.state.idTipoPublicacion}
                                onMenuOpen={this.mapTipoPublicacion}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                placeholder=""
                                styles={customStyle}
                            />
                        </div>
                    }

                    <div className={classIsModerador}>
                        <label className="label-oscura">Stock</label>
                        <Select
                            name="stock"
                            options={stockOpciones}
                            onMenuOpen={stockOpciones}
                            onChange={(e) => this.setState({ sinStock: e })}
                            value={this.state.sinStock}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            placeholder=""
                            styles={customStyle}
                        />
                    </div>

                    <div  className="row p-10">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <button
                                className="btn d-inline btn-sm btn-grey m-r-10"
                                disabled={loadingPublicaciones}
                                type='submit'
                            >
                                Buscar
                            </button>
                            <button
                                className="btn btn-sm btn-grey d-inline"
                                type='reset'
                            >
                                Limpiar
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    publicaciones: state.publicaciones.publicaciones,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    marcas: state.publicaciones.marcas,
    categorias: state.publicaciones.categorias,
    variaciones: state.publicaciones.variacionesPublicacion,
    sellers: state.sellers.filteredSellers,
    idSeller: state.general.idSeller,
    tipoPublicacion: state.tiposPublicacion.tiposPublicaciones.elementos
});

export default connect(mapStateToProps, {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    fetchSellersFilter,
    setFiltroPublicacion
})(PublicacionesFilter);